import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import FullScreenDialog from './FullScreenDialog'
import Button from '@material-ui/core/Button'


const styles = (theme) => {
    return ({
        card: {
            marginBottom: '20px'
        },
        cardTitle: {
            marginLeft: '15px',
            marginTop: '15px',
        },
    })
};

class ConfirmationDialog extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
            
    //     }
    // }
    

    render() {
        const { classes } = this.props;
        const extra_buttons = []
        extra_buttons.push(
            <Button onClick={this.props.handleContinue} color="primary" variant="contained">Ok</Button>
        )

        return (
            <FullScreenDialog
                open={true}
                title={this.props.title || 'Confirm'}
                bodyPadding="20px"
                handleClose={this.props.handleClose}
                fullScreen={false}
                extraButtons={extra_buttons}
                hide_save_button={true}
            >
                <div style={{minWidth: 300}}>
                    {
                        this.props.content || <div>Are you sure?</div>
                    }
                </div>

            </FullScreenDialog>
        )
    }
}

export default withStyles(styles)(ConfirmationDialog);